<div class="rs-maxh rs-padding-bottom2" data-cy="nortonDownloadSection">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col">
    <h3 class="rs-tit6">{{ 'norton.download.title' | translate }}</h3>
    <p>{{ 'norton.download.description' | translate }}</p>
    <a
      href="{{ downloadLink }}"
      [ngClass]="{
        'rs-btn-waiting': !key || isPending
      }"
      class="rs-btn"
      target="_blank"
      >{{ 'norton.download.label' | translate
      }}<i class="icon-Target-Blank rs-margin-left1"
        ><span class="show-for-sr">{{
          'norton.download.openWindow.accessibility' | translate
        }}</span></i
      >
      <div *ngIf="!key || isPending" class="rs-btn-waiting-dots"></div>
    </a>
  </div>
</div>
